// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close-to-bottom-left[data-v-47793642]{left:8px;bottom:8px}", ""]);
// Exports
module.exports = exports;
